import React from "react";
import { Box, Chip } from "@mui/material";
import { StatusTone, statusColors, getStatusTone } from "./StatusTokens";

interface StatusChipProps {
  label: string;
  tone?: StatusTone;
  size?: "small" | "medium";
}

/**
 * Enhanced StatusChip following HRIS-MVP & Mobile App theme.
 * Displays a soft tinted background with a clean colored dot badge and crisp typography.
 */
export function StatusChip({ label, tone, size = "small" }: StatusChipProps) {
  const effectiveTone = tone || getStatusTone(label);
  const { fg, bg } = statusColors[effectiveTone] || statusColors.neutral;

  return (
    <Chip
      size={size}
      label={label}
      icon={
        <Box
          component="span"
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            bgcolor: fg,
            ml: "8px !important",
            flexShrink: 0,
          }}
        />
      }
      sx={{
        bgcolor: bg,
        color: fg,
        fontSize: 12,
        fontWeight: 650,
        height: size === "small" ? 24 : 28,
        borderRadius: "4px",
        border: `1px solid ${fg}22`,
        "& .MuiChip-label": {
          px: 1,
          letterSpacing: "0.02em",
        },
      }}
    />
  );
}
